import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './ContactInput.css';

export default class ContactInput extends React.Component {
  
  static propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    type: PropTypes.oneOf(['TEXT', 'MESSAGE', 'EMAIL', 'PHONE', 'SELECT']).isRequired,
    required: PropTypes.bool,
    title: PropTypes.node,
    error: PropTypes.node,
    maxLength: PropTypes.number,
    value: PropTypes.string,
    onChangeInput: PropTypes.func,
    options: PropTypes.array
  };

  render() {
    const { type } = this.props;
    return (
      <div className={classnames('ContactInput', this.props.className, {
        error: !!this.props.error
      })}>
        <div className="ContactInput__labels">
          <div className="ContactInput__titleLabel">
            {this.props.title}
            {
              this.props.required &&
              ` *`
            }
          </div>
          {
            this.props.error &&
            <div className="ContactInput__errorLabel">
              {`(`}
              {this.props.error}
              {`)`}
            </div>
          }
        </div>
        {
          (type === 'TEXT' || type === 'EMAIL' || type === 'PHONE') &&
          <input
            className="ContactInput__input"
            type="text"
            name={this.props.id}
            autoCorrect="off"
            spellCheck="false"
            maxLength={this.props.maxLength}
            value={this.props.value}
            onChange={this.props.onChangeInput.bind(this, this.props.id)}
          />
        }
        {
          type === 'MESSAGE' &&
          <textarea 
            className="ContactInput__textarea"
            name={this.props.id}
            autoComplete="off"
            maxLength={this.props.maxLength}
            value={this.props.value}
            onChange={this.props.onChangeInput.bind(this, this.props.id)}
          />
        }
        {
          type === 'SELECT' &&
          <select
            className="ContactInput__select"
            value={this.props.value}
            onChange={this.props.onChangeInput.bind(this, this.props.id)}>
            <option value="">  </option>
            {
              this.props.options.map((option, idx) => (
                <option
                  key={idx}
                  value={option}>
                  {` ${option} `}
                </option>
              ))
            }
          </select>
        }
      </div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/components/ContactInput.js